import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import _ from 'underscore';
import DialogInterface from '@/interfaces/dialog';
import DeviceView from '@/views/device';
import template from '@/../templates/dialog-device-settings.hbs';

var MAX_NAME_LENGTH = 100;
var globalCh = Radio.channel('global');
var alertCh = Radio.channel('alerts');

var view = DeviceView.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        name: '#device-settings-modal-name',
        description: '#device-settings-modal-description',
        submitButton: 'button.submit',
        name_help_block: '.name-counter',
        form: 'form',
        tabs: '.nav-tabs'
    },
    // we don't use regions in this view, though device view has them
    // creating empty regions poses problems for listeners, that are
    // not easily cleaned up
    regions: {},
    templateContext: function(){
        var d = {};
        d.status = this.model.get('device_online') ? 'online' : 'offline';
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        // Check if the active account can update device attributes on given device
        // This depends on the owner of the DEVICEGROUP, not the owner of the device
        // This also depends on devicegroup type
        // First "if" necessary to avoid "cannot read ___ of undefined" errors (other blocks wont run)
        if (!this.model.rel.get('devicegroup')) {
            if (active.permits(primary, 'update_unassigned_device')) {
                d.update_device = true;
            } else if (this.model.rel.get('owner') === primary){
                d.update_device = true;
            } else {
                d.update_device = false;
            }
        } else if (this.model.rel.get('owner') === primary) {
            d.update_device = true;
        } else if (
            this.model.rel.get('devicegroup').type === this.model.rel.get('devicegroup').TYPES_MAP.development
            && this.model.rel.get('devicegroup').rel.get('owner').permits(primary, 'update_development_device')) {
                d.update_device = true;
        } else if (
            this.model.rel.get('devicegroup').type === this.model.rel.get('devicegroup').TYPES_MAP.factoryfixture
            && this.model.rel.get('devicegroup').rel.get('owner').permits(primary, 'update_factory_device')) {
                d.update_device = true;
        } else if (
            this.model.rel.get('devicegroup').type === this.model.rel.get('devicegroup').TYPES_MAP.pre_factoryfixture
            && this.model.rel.get('devicegroup').rel.get('owner').permits(primary, 'update_pre_factory_device')) {
                d.update_device = true;
        } else if (
            this.model.rel.get('devicegroup').type === this.model.rel.get('devicegroup').TYPES_MAP.pre_production
            && this.model.rel.get('devicegroup').rel.get('owner').permits(primary, 'update_pre_production_device')) {
                d.update_device = true;
        } else if (
            this.model.rel.get('devicegroup').type === this.model.rel.get('devicegroup').TYPES_MAP.production
            && this.model.rel.get('devicegroup').rel.get('owner').permits(primary, 'update_production_device')) {
                d.update_device = true;
        } else {
            d.update_device = false;
        }
        return d;
    },
    onRender: function(){
        this.check_validation(
            this.ui.name,
            MAX_NAME_LENGTH,
            this.ui.name_help_block,
            this.ui.submitButton);
        this.ui.tabs.tab();
    },
    events: {
        'submit form': 'onSubmit',
        'change @ui.name': 'validateName',
        'keyup @ui.name': 'validateName',
        'paste @ui.name': 'validateName',
        'mouseup @ui.name': 'validateName'
    },
    validateName: function (e) {
        var $target = $(e.target);

        if ( $target.val() === '' ){
            this.ui.submitButton.prop('disabled', false);
        } else {
            this.check_validation(
                $target,
                MAX_NAME_LENGTH,
                this.ui.name_help_block,
                this.ui.submitButton);                
        }
    },
    initialize: function () {
        this.destroyOnClose();
    },

    onSubmit: function (e) {
        var form_data = {};
        var self = this;

        e.preventDefault();

        // get form values
        this.ui.form.serializeArray().forEach(function (obj) {
            form_data[obj.name] = obj.value;
        });

        // Remove whitespace
        form_data.name = form_data.name.trim();

        var options = {
            success: function (model, response) {
                var message = 'Device "' + ( model.get('name') || model.get('id') ) + '" successfully updated';
                alertCh.request('showAlert', { message: message, messageType: 'success' });
                // Close the modal
                self.closeDialog();
            },
            error: function (model, resp, options) {
                var msg;
                var err = resp.responseJSON.errors[0] || undefined;
                var ui_element = _.flatten(err.detail.split(" ", 1));

                try {
                    msg = err.detail;
                } catch (e) {
                    console.error(e);
                    msg = "no message text";
                    return;
                }

                self.showAlert('danger', msg);

                if (self.ui[ui_element]) {
                    self.ui[ui_element].addClass("has-error");
                }
            },
            patch: true,
            wait: true
        };
        var attrs = {};
        if ('name' in form_data) {
            attrs.name = form_data.name;
        }
        this.model.save({
            data: {
                type: 'device',
                id: this.model.id,
                attributes: attrs
            }
        }, options);
    }
});
export default view;
